<template>
  <div class="sidebar-account">
    <div class="text lead mb-0">
      <span class="mr-2">{{ getInitials() }}</span>
      <span class="ban mr-2" v-if="isBannedUser">
        <font-awesome-icon :icon="['fa', 'ban']" id="banTarget" />
        <b-popover target="banTarget" triggers="hover" placement="bottom">
          <template v-slot:title>Заблокирован</template>
          <div class="popover-content" v-html="getBan()" />
        </b-popover>
      </span>
      <font-awesome-icon
        :icon="['fa', 'question-circle']"
        class="mr-2 text-muted"
        id="target"
      />
      <b-popover target="target" triggers="hover" placement="bottom">
        <template v-slot:title>Список прав пользователя</template>
        <div class="popover-content" v-html="getRightsDescription()"></div>
      </b-popover>
    </div>
    <p class="text text-muted mb-2">{{ getDepartmentsFromLK() }}</p>
    <p class="text text-muted mb-2">{{ getDepartments() }}</p>
    <p class="text text-muted mb-0">{{ getRoles() }}</p>

    <p></p>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { userMappers } from '@/store/modules/user'
import { rolesTranslation } from '@/config/roles'
import { PermissionManager } from '@/api/permissions/AbilityBuilder'
import dateFormat from '@/config/dateFormat'
import moment from 'moment'

const Mappers = Vue.extend({
  computed: {
    ...userMappers.mapGetters([
      'currentUser',
      'userRoles',
      'userDepartments',
      'lkDepartments',
      'partnerPosition',
      'isBannedUser',
      'banReason',
      'banDate'
    ])
  }
})

@Component
export default class Profile extends Mappers {
  private getInitials() {
    return this.currentUser && this.currentUser.initials
      ? this.currentUser.initials
      : 'Неизвестный'
  }

  private getRoles() {
    return this.userRoles.map((r: string) => rolesTranslation[r]).join(', ')
  }
  private getDepartments() {
    return this.userDepartments.map(d => d.shortTitle).join(', ')
  }
  private getDepartmentsFromLK() {
    return this.lkDepartments
      .map(d => `${d.workPosition.shortTitle} ${d.workDepartment.shortTitle}`)
      .join(', ')
  }

  private getBan() {
    return `Дата блокировки: ${
      this.banDate
        ? moment(this.banDate).format(dateFormat.date.localFormat)
        : 'неизвестно'
    }<br>Причина: ${this.banReason ? this.banReason : 'не указана'}`
  }

  private static generateDescription(title: string, list?: string[]) {
    let text = ''
    if (list && list.length) {
      text += `<b>${title}:</b><br>`
      text += list.join('<br>')
      text += '<br><br>'
    }
    return text
  }

  private getRightsDescription() {
    let text = ''

    text += Profile.generateDescription(
      'Права',
      PermissionManager.translateAbility(PermissionManager.common())
    )

    if (!text) return 'Пользователь не имеет дополнительные права.'

    return text
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.ban {
  color: map-get($french-palette, 'red-3');
}
.text {
  padding: 0rem 1rem;
}
.popover-content {
  overflow-y: auto !important;
  max-height: 65vh;
}
</style>
